import { FC, useCallback, memo, useState } from "react";
import styles from "./styles.module.css";
import { Space } from "antd";
import { Surface } from "components/Surface";

import { debounce } from "utils/lodash";
import { colors } from "utils/colors";
import clsx from "clsx";
import { useEffect } from "react";

interface ColorBoxProps {
  onClick: (hex: string) => void;
  color: string;
  active?: boolean;
}

const ColorBox: FC<ColorBoxProps> = ({ color, onClick, active }) => {
  const handleClick = useCallback((e) => {
    e.preventDefault();
    onClick && onClick(color);
  }, []);

  return (
    <Surface
      onClick={handleClick}
      style={{ background: color }}
      hoverable
      className={clsx(styles.colorBox, active && styles.active)}
    />
  );
};

interface ColorPickerProps {
  onChange?: (hex: string) => void;
  initValue?: string;
  className?: string;
  name: string;
}

const ColorPicker: FC<ColorPickerProps> = ({
  initValue = "#ffffff",
  onChange,
  className,
  name,
}) => {
  const [active, setActive] = useState<number>(-1);

  // Init default value to state
  useEffect(() => {
    const activeIndex = colors.indexOf(initValue);
    if (activeIndex === -1) return;
    setActive(activeIndex);
  }, [initValue]);

  const handleColorChange = useCallback((color: string, key: number) => {
    onChange && onChange(color);
    setActive(key);
  }, []);
  const handleinputChange = useCallback(
    debounce((e: any) => {
      onChange && onChange(e.target.value);
    }, 500),
    []
  );
  return (
    <Space align="center" className={className}>
      <input
        defaultValue={initValue}
        onChange={handleinputChange}
        name={name}
        type="color"
        className="f-center"
      />
      <div className="mx-8 secondary semi-bold nowrap">OR</div>

      <Space align="center">
        {colors.slice(0, 6).map((color, i) => (
          <ColorBox
            key={color}
            active={active === i}
            color={color}
            onClick={() => handleColorChange(color, i)}
          />
        ))}
      </Space>
    </Space>
  );
};

export default memo(ColorPicker);
